import React from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Modal, { ModalButton } from '../../../ui/Modal';

const ConfirmCompletionModal = ({ onClose, onConfirm }) => (
  <Modal
    isOpen={true}
    onClose={onClose}
    title="Подтвердить завершение"
    subtitle="Отмеченные заказы будут переведены в статус «Доставлен»."
    size="sm"
    footer={
      <>
        <ModalButton variant="ghost" onClick={onClose}>Отмена</ModalButton>
        <ModalButton variant="primary" onClick={onConfirm}>
          <CheckCircleOutlineIcon sx={{ fontSize: 18 }} />
          Подтвердить
        </ModalButton>
      </>
    }
  >
    <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.55, color: '#6F6259' }}>
      Действие нельзя отменить. Клиенты получат уведомление о завершении доставки.
    </p>
  </Modal>
);

export default ConfirmCompletionModal;
